// Shared follow-up logic for Admin Leads dashboard + Overview "Follow-Ups" widget.
export const SALES_FINAL_STATUSES = ["won", "lost"];
export const CAREER_FINAL_STATUSES = ["selected", "rejected"];

function isFinal(lead) {
  const finals = lead.type === "career" ? CAREER_FINAL_STATUSES : SALES_FINAL_STATUSES;
  return finals.includes(lead.status);
}

// Returns "overdue" | "due_today" | "upcoming" | "none"
export function getFollowupStatus(lead) {
  if (!lead.follow_up_date) return "none";
  if (isFinal(lead)) return "none";
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const due = new Date(lead.follow_up_date); due.setHours(0, 0, 0, 0);
  if (due.getTime() < today.getTime()) return "overdue";
  if (due.getTime() === today.getTime()) return "due_today";
  return "upcoming";
}

const PRIORITY = { overdue: 0, due_today: 1, upcoming: 2, none: 3 };

// Sorts leads: overdue > due today > upcoming > no follow-up, each group by soonest follow-up date first.
export function sortByFollowup(leads) {
  return [...leads].sort((a, b) => {
    const pa = PRIORITY[getFollowupStatus(a)];
    const pb = PRIORITY[getFollowupStatus(b)];
    if (pa !== pb) return pa - pb;
    if (a.follow_up_date && b.follow_up_date) return a.follow_up_date.localeCompare(b.follow_up_date);
    return new Date(b.created_at) - new Date(a.created_at);
  });
}
